'use client';

import { useEffect } from 'react';

export function LandingPageCapture() {
  useEffect(() => {
    if (typeof window === 'undefined') return;

    try {
      const key = 'landingPage';
      if (!sessionStorage.getItem(key)) {
        sessionStorage.setItem(key, window.location.href);
      }
    } catch {
      // sessionStorage unavailable (private browsing, storage-blocked, sandboxed iframe, etc.)
    }
  }, []);

  return null;
}
